import React, { createContext, useContext, useEffect, useRef, useState } from "react";

const SubprodutoContext = createContext();

export const SubprodutoProvider = ({ children }) => {
  const [showSeletor, setShowSeletor] = useState(false);

  const subprodutoRef = useRef();

  const values = {
    showSeletor,
    setShowSeletor,
    subprodutoRef
  }

  useEffect(() => {
    subprodutoRef.current.subprod();
  }, [])

  return (
    <SubprodutoContext.Provider value={values}>
      {children}
    </SubprodutoContext.Provider>
  )

};

export const useSubprodutoContext = () => {
  const context = useContext(SubprodutoContext);
  if (!context) {
    throw new Error("useSubprodutoContext deve ser usado dentro de um SubprodutoProvider");
  }
  return context;
}